import React from "react";

import Tooltip from "antd/es/tooltip";
import { get } from "lodash-es";
import { useIntl } from "react-intl";

import { EntityType, Person } from "@mapmycustomers/shared/types/entity";

import ButtonLink from "@app/component/ButtonLink";
import { RegistryProps } from "@app/component/FieldGrid/utils/ComponentRegistry";
import useEntityLinkGetter from "@app/util/contexts/useEntityLinkGetter";

const PersonField = ({ entity, field }: RegistryProps) => {
  const intl = useIntl();
  const getEntityLink = useEntityLinkGetter();

  const personName = field.getFormattedValueFor(entity);
  const person = get(entity, field.name) as Person;

  return (
    <Tooltip
      placement="bottom"
      title={intl.formatMessage({
        id: "fieldGrid.field.person.tooltip",
        defaultMessage: "Open Person",
        description: "Open person tooltip",
      })}
    >
      <ButtonLink href={getEntityLink(EntityType.PERSON, person.id)} target="_blank">
        {personName}
      </ButtonLink>
    </Tooltip>
  );
};

export default PersonField;
